import PropTypes from 'prop-types'
import { Nav } from 'react-bootstrap'

import AccessibilityFeaturesNavItem
  from './navItems/AccessibilityFeaturesNavItem'
import ChaptersNavItem from './navItems/ChaptersNavItem'
import DetailsNavItem from './navItems/DetailsNavItem'
import PackagesNavItem from './navItems/PackagesNavItem'
import TableOfContentsNavItem from './navItems/TableOfContentsNavItem'

const Navigation = ({ isPrint, kind, setEventKey }) => {
  const displayAccessibilityTab = kind !== 'Package'

  return (
    <div className='pdp_page__content'>
      <div className='pdp_page__content__wrap pb-0'>
        <Nav className='nav-tabs d-flex'>
          <DetailsNavItem handleOnClick={setEventKey} />
          {!isPrint && (
            <>
              <TableOfContentsNavItem handleOnClick={setEventKey} />
              <PackagesNavItem handleOnClick={setEventKey} />
              <ChaptersNavItem handleOnClick={setEventKey} />
              {displayAccessibilityTab
                && <AccessibilityFeaturesNavItem handleOnClick={setEventKey} />
              }
            </>
          )}
        </Nav>
      </div>
    </div>
  )
}

export default Navigation

Navigation.propTypes = {
  isPrint: PropTypes.bool.isRequired,
  kind: PropTypes.string,
  setEventKey: PropTypes.func.isRequired
}
